import { useTranslation } from 'react-i18next';
import { Header, LwTab, ModalPanelTabType, Page, Toolbox } from 'redesign';
import { RenderUnsettledUI } from 'shared/components/render-unsettled-ui/render-unsettled-ui';
import { Box, styled, Tabs, tabsClasses } from '@mui/material';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { useGetServiceAgreementsForCompany } from 'ogp/hooks/queryHooks/service-agreements/use-get-service-agreements-for-company';
import { useState } from 'react';
import { useGetCollegialLendingScreenTabs } from './hooks/use-get-collegial-lending-screen-tabs';

export const CollegialLendingDataProvider = () => {
  const serviceAgreementsQuery = useGetServiceAgreementsForCompany();

  if (serviceAgreementsQuery.status !== 'success' || !serviceAgreementsQuery.data) {
    return <RenderUnsettledUI data={serviceAgreementsQuery} />;
  }

  return <CollegialLending data={serviceAgreementsQuery.data} />;
};
export const CollegialLending = ({ data }: { data: ServiceAgreementsResponse }) => {
  const { t } = useTranslation('ogp-screen-specific');

  const tabs: ModalPanelTabType[] = useGetCollegialLendingScreenTabs(data.length > 0 ? data : []);
  const [selectedTab, setSelectedTab] = useState(tabs[0]);

  return (
    <Page
      header={<Header titleText={t('collegial_lending_page.title')} />}
      toolbox={<Toolbox></Toolbox>}
    >
      <Box width="100%">
        <Box mb={4}>
          <StyledTabs
            value={selectedTab.id}
            onChange={(_, tabId) => {
              const selectedTab = tabs.find((i) => i.id === tabId) ?? tabs[0].id;
              setSelectedTab(selectedTab);
            }}
            aria-label="partner-detail-tabs"
          >
            {tabs.map((tab) => (
              <LwTab key={tab.id} value={tab.id} label={tab.tabLabel} />
            ))}
          </StyledTabs>
        </Box>
        <Box>{selectedTab.element}</Box>
      </Box>
    </Page>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  [`& div.${tabsClasses.scroller}`]: {
    [`& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(2),
      overflow: 'visible',
    },
  },
}));
